import React, { useState, useEffect, useCallback } from 'react';
import api from '../lib/api';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { TrendingUp, TrendingDown, ArrowRightLeft } from 'lucide-react';

const WMSMovementsPage = () => {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMovements = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/stock-movements', { params: { limit: 100 } });
      setMovements(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMovements(); }, [fetchMovements]);

  const getMovementIcon = (type) => {
    switch(type) {
      case 'in': return <TrendingUp className="w-4 h-4 text-green-600" />;
      case 'out': return <TrendingDown className="w-4 h-4 text-red-600" />;
      case 'transfer': return <ArrowRightLeft className="w-4 h-4 text-blue-600" />;
      default: return null;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Miscari Stoc - WMS</h1>
        <p className="text-slate-600 mt-1">Istoric complet miscari intrari/iesiri/transferuri</p>
      </div>
      
      <div className="space-y-2">
        {movements.map((movement) => (
          <Card key={movement.id}>
            <CardContent className="p-4">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div className="flex items-center gap-3">
                  {getMovementIcon(movement.movement_type)}
                  <div>
                    <p className="font-medium">{movement.article_name || 'N/A'}</p>
                    <p className="text-sm text-slate-500">
                      {new Date(movement.created_at).toLocaleString('ro-RO')}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-semibold">{movement.quantity} {movement.unit || 'buc'}</p>
                  <p className="text-xs text-slate-400">{movement.movement_type}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default WMSMovementsPage;